import { useTimeoutFn, useUnmount } from "react-use"
import { useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { NotificationBanner } from "components/NotificationBanner/NotificationBanner"
import { useGetUpcomingCall } from "modules/Call/queries"
import { CallBanner } from "modules/Call/components/CallBanner"
import { useGetMostImportantBookings } from "modules/ClientAccount/hooks"
import { CALL_WARNING_BEFORE } from "modules/Call/common/constants"

export const ClientCallNotification = () => {
    const location = useLocation()
    const [{ isVerified }] = useClientContext()
    const [isGetStatus, setIsGetStatus] = useState<boolean>(false)
    const { data: ongoingBookings } = useGetMostImportantBookings(isVerified)
    const { dataUpdatedAt, data, error } = useGetUpcomingCall(isGetStatus)
    const navigate = useNavigate()

    useEffect(() => {
        if (error) {
            NotificationBanner.clear()
            return
        }
        if (!data) return

        NotificationBanner.notify({
            message: (
                <CallBanner
                    bookingHash={data.booking.booking_hash}
                    sessionStartDatetime={data.booking.session_start_datetime}
                    navigate={navigate}
                />
            ),
        })
    }, [data, error, location, dataUpdatedAt])

    const timeout = useMemo(() => {
        if (!(ongoingBookings && ongoingBookings.length)) return 2147483647
        const nextSessionDateTime = new Date(ongoingBookings[0].session_start_datetime)
        const timeout = nextSessionDateTime.getTime() - new Date().getTime() - CALL_WARNING_BEFORE
        return timeout > 0 ? timeout : 0
    }, [ongoingBookings])

    useTimeoutFn(() => {
        setIsGetStatus(true)
    }, timeout)

    useUnmount(() => {
        NotificationBanner.clear()
    })

    return null
}
